import React, { useMemo } from 'react'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'

import SlotTheme from './slotTheme'
import constants from 'shared/src/constants'
import utils from 'shared/src/utils'
import icons from 'icons'

const ArrowIcon = icons.arrowForward
const BlockedIcon = icons.blocked
const LockedIcon = icons.locked

const useStyles = makeStyles(theme => {
  const slotTheme = SlotTheme(theme)
  return {
    slot: {
      marginBottom: theme.spacing(1),
    },
    choosenSlot: {
      ...slotTheme.choosenSlot
    },
    blockedSlot: {
      ...slotTheme.blockedSlot,
    },
    adminOnlySlot: {
      ...slotTheme.adminOnlySlot
    },
    bookedSlot: {
      ...slotTheme.bookedSlot
    },
    reservedSlot: {
      ...slotTheme.reservedSlot
    },
    partiallyBookedSlot: {
      ...slotTheme.partiallyBookedSlot
    },
  }
})

const CalendarSlot = ({
  admin,
  slot,
  config,
  choosenSlot,
  wrapTitle,
  onClickSlot,
}) => {
  const classes = useStyles()

  const templateValues = slot._calculated
  const isChoosenSlot = choosenSlot && choosenSlot.index == slot.index && choosenSlot.date == slot.date
  const isBlocked = isChoosenSlot ? false : utils.isSlotBlocked(slot)
  const isAdminOnly = isChoosenSlot ? false : utils.isSlotAdminOnly(slot)
  const canBook = isChoosenSlot ? true : templateValues.canBook
  const hasBookings = slot.bookingRecords && slot.bookingRecords.length > 0
  const hasReservedBookings = slot.bookingRecords && slot.bookingRecords.find(b => b.status == constants.BOOKING_STATUS_RESERVED) ? true : false
  const disabled = isBlocked || !canBook

  const isActive = admin || !disabled

  const isChoosen = 
    choosenSlot &&
    choosenSlot.date == slot.date &&
    choosenSlot.index == slot.index

  const slotClassname = classnames({
    [classes.slot]: true,
    [classes.choosenSlot]: !admin && isChoosen,
    [classes.blockedSlot]: admin && isBlocked,
    [classes.adminOnlySlot]: admin && isAdminOnly,
    [classes.reservedSlot]: admin && hasReservedBookings,
    [classes.bookedSlot]: admin && !canBook,
    [classes.partiallyBookedSlot]: admin && canBook && hasBookings,
  })

  let IconClass = ArrowIcon

  if(admin && isBlocked) {
    IconClass = BlockedIcon
  }
  else if(admin && isAdminOnly) {
    IconClass = LockedIcon
  }

  const button = isActive ? (
    <IconButton
      edge="end"
      disabled={ !isActive }
      onClick={ () => onClickSlot(slot) }
    >
      {
        isBlocked 
      }
      <IconClass />
    </IconButton>
  ) : null

  const title = (
    <div>
      { templateValues.title }&nbsp;&nbsp;{ wrapTitle ? wrapTitle('   ', slot) : ' ' }
    </div>
  )

  return (
    <ListItem
      button
      disabled={ !isActive }
      className={ slotClassname }
      onClick={ () => onClickSlot(slot) }
    >
      <ListItemText
        primary={ title }
        secondary={ templateValues.subtitle }
      />
      {
        isActive && (
          <ListItemSecondaryAction>
            { button }
          </ListItemSecondaryAction>
        )
      }
    </ListItem>
  )
}

export default CalendarSlot